import React, { Component, PropTypes } from 'react';

import moment from 'moment';

import { NitroPlaceholder, NitroDatePicker, NitroText } from 'nitro-components';

import {
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_SET_ALLOC_DATE
} from '../content';

class ExistingDriverTab extends Component {

  setAllocationDate = (date) => {
    this.props.setDriverDetails({
      target: { name: 'existingDriverAllocationDate', value: date }
    });
  };

  render() {
    const { existingDriverAllocationDate } = this.props.driverDetails;

    const minDate = moment().subtract(1, 'month').toDate();

    return (
      <div>
        <NitroDatePicker
          placeholder={ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_SET_ALLOC_DATE}
          value={existingDriverAllocationDate}
          onChange={this.setAllocationDate}
           minDate={minDate}
        />

        <NitroPlaceholder size={30} />

      </div>
    );
  }
}

ExistingDriverTab.propTypes = {
  country: PropTypes.object,
  driverDetails: PropTypes.object,
  setDriverDetails: PropTypes.func,
  driverProfile: PropTypes.object
};

export default ExistingDriverTab;



// WEBPACK FOOTER //
// ./src/features/relocations/driver/components/RedirectedDriverTab.js